import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { loaderHandler } from "src/lib/loaderHandler";
import { McpConnectPage } from "src/pages/McpConnectPage";

const routeSearchSchema = z.object({
  response_type: z.literal("code"),
  client_id: z.string(),
  redirect_uri: z.string(),
  code_challenge: z.string(),
  code_challenge_method: z.literal("S256"),
  resource: z.string(),
  state: z.string().optional(),
  scope: z.string().optional(),
});

export const Route = createFileRoute("/_hybrid/connect")({
  component: McpConnectPage,
  ssr: true,
  validateSearch: routeSearchSchema,
  headers: () => {
    return {
      "X-Frame-Options": "DENY",
      "Content-Security-Policy": "frame-ancestors 'none'",
    };
  },
  loader: ({ location }) => {
    return loaderHandler((ctx) => {
      if (!ctx.session?.user) {
        throw redirect({
          to: "/sign-in",
          search: { redirect: location.href },
        });
      }
    });
  },
  staticData: {
    getLayoutSettings() {
      return {
        useAuthLayout: false,
      };
    },
  },
});
